const accordionItems = document.querySelectorAll('.accordion-item');

// Add a click event listener to each accordion item
accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-item__header');
    const content = item.querySelector('.accordion-item__content');

    header.addEventListener('click', () => {
        if (item.classList.contains('active')) {
            item.classList.remove('active');
        } else {
            item.classList.add('active');
        }
    });
});
